import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { AppI18nProvider } from "./components/i18n/AppI18nProvider";
import { ensureAppFresh } from "./app/update";
import "../../web/src/styles/tokens.css";
import "./styles/main.css";

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<ErrorBoundary>
			<AppI18nProvider>
				<RouterProvider router={router} />
			</AppI18nProvider>
		</ErrorBoundary>
	</StrictMode>,
);

void ensureAppFresh();
window.addEventListener("visibilitychange", () => {
	if (document.visibilityState === "visible") void ensureAppFresh();
});
